import { Apple, PlayStore } from "../../common/svg/AllSvg";
import { useTranslation } from "react-i18next";
import { dataActions } from "../../../shared/store/data-Slice";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

const DownloadApp = () => {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();

    const handleLink = (item: any) => {
        dispatch(dataActions.setWebOpen(true));
        dispatch(dataActions.setLink(item));
    }

    return (
        <div className="w-full h-full pb-[35px] sm:pb-[40px] lg:pb-[50px] xl:pb-[60px]">
            <div className="container h-full w-full">
                <div className="w-full h-full rounded-[20px] lg:rounded-[40px] xl:rounded-[60px] dark:bg-[#135963] bg-[#C0F4FB] relative p-[30px] sm:p-[40px] !pb-0 msm:!pt-0 msm:px-[64px] flex items-center msm:justify-between msm:flex-row flex-col">
                    <div className="absolute top-0 left-0 bottom-0 right-0 flex items-end justify-end w-full h-full rounded-[76px]">
                        <img src={require("../../../assets/images/app-bg-img.png")} alt="app-bg-img" className="rounded-[20px] lg:rounded-[40px] xl:rounded-[60px] w-full dark:sepia" />
                    </div>

                    <div className="flex flex-col gap-[10px] md:gap-[15px] xl:gap-[20px]">
                        <h3 className="text-blackDark dark:text-textBlackDull font-semibold z-[1]">{t("passenger.home.download_app.title")}</h3>
                        <h1 className="max-w-[400px] msm:max-w-[557px] text-primaryText dark:text-textBlackDull font-bold z-[1]">{t("passenger.home.download_app.subtitle")}</h1>

                        <div className="mt-[20px] md:mt-[25px] xl:mt-[32px] flex xsm:items-center gap-[8px] md:gap-[15px] xsm:flex-row flex-col">
                            <Link to="https://play.google.com/store/apps/details?id=com.metroconnect3.app" target="_blank" onClick={(e) => { handleLink("https://play.google.com/store/apps/details?id=com.metroconnect3.app"); e.preventDefault(); }} className="flex items-center gap-[14px] z-[1] justify-center rounded-[10px] bg-[#000] h-[50px] md:h-[60px] px-[16px] mm:px-[21px] w-fit focus:shadow-[0_0_0_3px_#3d3d3d5e] hover:shadow-[0_0_0_3px_#3d3d3d5e]">
                                <div className="min-w-[29px]">
                                    <PlayStore />
                                </div>
                                <div className="flex flex-col">
                                    <h2 className="text-white font-normal text-left text-sm leading-snug">{t("passenger.home.download_app.btn1.title")}</h2>
                                    <h3 className="uppercase text-white font-extrabold text-left text-base leading-snug">{t("passenger.home.download_app.btn1.sub")}</h3>
                                </div>
                            </Link>
                            <Link to="https://apps.apple.com/us/app/metroconnect3/id6723876321" target="_blank" onClick={(e) => { handleLink("https://apps.apple.com/us/app/metroconnect3/id6723876321"); e.preventDefault(); }} className="flex items-center gap-[14px] z-[1] justify-center rounded-[10px] bg-[#000] h-[50px] md:h-[60px] px-[16px] mm:px-[21px] w-fit focus:shadow-[0_0_0_3px_#3d3d3d5e] hover:shadow-[0_0_0_3px_#3d3d3d5e]">
                                <div className="min-w-[27px]">
                                    <Apple className="fill-white" />
                                </div>
                                <div className="flex flex-col">
                                    <h4 className="text-white font-normal text-left text-sm leading-snug">{t("passenger.home.download_app.btn2.title")}</h4>
                                    <h5 className="uppercase text-white font-extrabold text-left">{t("passenger.home.download_app.btn2.sub")}</h5>
                                </div>
                            </Link>
                        </div>
                    </div>

                    <div className="h-full flex msm:items-end msm:justify-end msm:!pt-[30px]">
                        <img src={require("../../../assets/images/mobile.png")} alt="mobile" className="z-[1] w-[598px]" />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default DownloadApp;